var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgProfileInactive = function SvgProfileInactive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 23 22"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#A8A8A8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M11.647 9.964a1.7 1.7 0 0 0-.303 0 4.05 4.05 0 0 1-3.914-4.06 4.067 4.067 0 0 1 4.07-4.07 4.066 4.066 0 0 1 .147 8.13M7.063 13.347c-2.218 1.485-2.218 3.905 0 5.38 2.521 1.687 6.655 1.687 9.176 0 2.218-1.485 2.218-3.905 0-5.38-2.512-1.678-6.646-1.678-9.176 0"
  })));
};
export default SvgProfileInactive;